import React from "react";
import { Tag } from "primereact/tag";

interface SectionStatusBadgeProps {
  loading: boolean;
  error: boolean;
  count: number;
  singular: string;
  plural: string;
}

// Shown next to a section heading and, crucially, still visible once the section
// is collapsed — so an empty queue (green) can be told apart from one that still
// needs work (orange) without expanding it.
export default function SectionStatusBadge({
  loading,
  error,
  count,
  singular,
  plural,
}: SectionStatusBadgeProps) {
  if (loading) {
    return null;
  }

  if (error) {
    return <Tag severity="danger" value="Could not be loaded" />;
  }

  return (
    <Tag
      severity={count === 0 ? "success" : "warning"}
      value={`${count} ${count === 1 ? singular : plural}`}
    />
  );
}
